import { css } from '@linaria/atomic';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Modal, ModalControlModalProps, Text } from '@frontend/design-system';

interface Props extends ModalControlModalProps {
  organizationName?: string;
  onConfirm: () => void;
}

export const DeleteDemoOrganizationModal = ({ organizationName, onConfirm, ...modalProps }: Props) => {
  const { t } = useTranslation('demo-location-ui');

  const handleConfirm = () => {
    onConfirm();
    modalProps.onClose();
  };

  return (
    <Modal {...modalProps} maxWidth={550}>
      <Modal.Header onClose={modalProps.onClose}>{t('Delete Demo Organization')}</Modal.Header>
      <Modal.Body className={bodyStyles}>
        <Text>
          {t('This will remove the demo organization and all associated locations. This action is permanent.')}
        </Text>
      </Modal.Body>
      <Modal.Footer
        primary={{
          label: t('Remove'),
          onClick: handleConfirm,
          destructive: true,
        }}
        secondary={{
          label: t('Cancel'),
          onClick: modalProps.onClose,
        }}
      />
    </Modal>
  );
};

const bodyStyles = css`
  padding-top: ${theme.spacing(3)};
  padding-right: ${theme.spacing(3)};
  padding-bottom: ${theme.spacing(3)};
  padding-left: ${theme.spacing(3)};
`;
